import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {Project} from "./projectDomain";

@entityConfig()
export class ProjectVersion extends DomainAncestor {
  @observable versionId: number;
  @observable version: string;
  @observable description: string;
  @observable project : Project
  @observable firstComment : string;
  @observable secondComment : string;
  @observable thirdComment : string;
  @observable fourthComment : string;

  @observable isCustom : boolean

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.versionId;
  }

  public setId(id: ID): void {
    this.versionId = <number>id;
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionDomain.ts